import { Component, input } from '@angular/core';
import { User } from 'shared/types/user.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-balance-tab',
  imports: [TranslatePipe],
  templateUrl: './balance-tab.component.html',
  styleUrl: './balance-tab.component.scss'
})
export class BalanceTabComponent {
  readonly user = input<User>();
  readonly ganasShared = input<number>();
  readonly ganamigoGanasShared = input<number>(0);
}
